import React from 'react';
import { getCountryName } from '../../utils/helpers/CorrectCountryNames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface FlagProps {
    code?: string;
    className?: string;
}

const Flag: React.FC<FlagProps> = ({ code, className = '' }) => {
    if (!code) return null;

    return (
        <OverlayTrigger placement="top" overlay={<Tooltip id="impressions-tooltip">{getCountryName(code)}</Tooltip>}>
            <img
                className={`country-flag rounded cursor-pointer shadow ${className}`}
                src={'/flags/4x3/' + code?.toLocaleLowerCase() + '.svg'}
                alt={getCountryName(code)}
            />
        </OverlayTrigger>
    );
};

export default Flag;
